// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"0e63e29291574c12","537":"fac7b7e40af7496c"}[chunkId] + ".js";
};